import { apiClient } from './client';

const reported = new Set<string>();

/**
 * Tells the server that an image would not load in this browser. Images come straight from object storage via
 * presigned URLs, so the server never sees the failure otherwise. Fire-and-forget: it must never disturb the page,
 * and each image is reported once per page load. Only the host of the URL is sent (the full URL is a signed secret).
 */
export function reportImageLoadFailure(kind: 'thumbnail' | 'preview' | 'full', url: string, submissionId?: string): void {
  try {
    const key = `${kind}:${url}`;
    if (reported.has(key)) return;
    reported.add(key);

    let host: string | undefined;
    try {
      host = new URL(url, window.location.href).host;
    } catch {
      host = undefined;
    }

    void apiClient
      .post('/telemetry/image-load-failure', {
        kind,
        submissionId,
        host,
        online: navigator.onLine,
        page: window.location.pathname.replace(/[0-9a-f]{8}-[0-9a-f-]{27}/gi, ':id'),
      })
      .catch(() => undefined);
  } catch {
    // reporting is best effort
  }
}
